module.exports = __webpack_public_path__ + "img/inactive-star.b5b0d00.svg";